import { useState } from 'react';
import { Server, ChevronsDown, ChevronsUp } from 'lucide-react';
import ServerRow from './ServerRow';
import './ServerSection.css';

/* ─── Score de sévérité pour le tri ─────────────────────── */
function severityScore(server) {
  const isOffline = (server.server_status || '').toLowerCase().includes('hors ligne');
  const maxAlerte = server.maxAlerte || 1;

  // Joignable avec métriques critiques → top priorité
  if (!isOffline && maxAlerte === 4) return 40 + maxAlerte;
  // Joignable avec anomalies
  if (!isOffline && maxAlerte >= 2)  return 20 + maxAlerte;
  // Injoignable
  if (isOffline)                     return 10;
  // OK
  return 0;
}

function sortByServerity(servers) {
  return [...servers].sort((a, b) => severityScore(b) - severityScore(a));
}

function filterByTab(servers, tab) {
  if (tab === 'replications') return servers.filter(s => s.server_type_id === 1 || s.server_type_id === 2);
  if (tab === 'backup')       return servers.filter(s => s.server_type_id === 3);
  return servers;
}

function ServerSection({ servers, onMetricClick, onOpenDrawer }) {
  const [activeTab,   setActiveTab]   = useState('replications');
  const [expandedIds, setExpandedIds] = useState(new Set());
  const [allOpen,     setAllOpen]     = useState(false);

  if (!servers || !servers.success) return null;

  const all     = servers.data;
  const replis  = sortByServerity(all.filter(s => s.server_type_id === 1 || s.server_type_id === 2));
  const backups = sortByServerity(all.filter(s => s.server_type_id === 3));
  const visible = activeTab === 'replications' ? replis : backups;

  function toggleRow(id) {
    setExpandedIds(prev => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id);
      else              next.add(id);
      return next;
    });
    setAllOpen(false);
  }

  function handleToggleAll() {
    if (allOpen) {
      setExpandedIds(new Set());
      setAllOpen(false);
    } else {
      setExpandedIds(new Set(visible.map(s => s.serveur_id || s.serveur_name)));
      setAllOpen(true);
    }
  }

  return (
    <section className="server-section">
      <div className="section-header">
        <h2 className="section-title">
          <Server size={14} className="section-title-icon" />
          Réplications bases de données
        </h2>
      </div>

      <div className="tab-row">
        <button
          className={`tab-btn ${activeTab === 'replications' ? 'active' : ''}`}
          onClick={() => setActiveTab('replications')}
        >
          Réplications ({replis.length})
        </button>
        <button
          className={`tab-btn ${activeTab === 'backup' ? 'active' : ''}`}
          onClick={() => setActiveTab('backup')}
        >
          Backup ({backups.length})
        </button>

        <div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', paddingBottom: 4 }}>
          <button
            onClick={handleToggleAll}
            style={{
              display: 'flex', alignItems: 'center', gap: 5,
              padding: '4px 12px', borderRadius: 'var(--radius-sm)',
              border: '1px solid var(--border-md)', background: 'white',
              fontSize: '0.78rem', fontWeight: 600, color: 'var(--text-secondary)',
              cursor: 'pointer', transition: 'all 0.15s ease',
            }}
          >
            {allOpen ? <ChevronsUp size={13} /> : <ChevronsDown size={13} />}
            {allOpen ? 'Tout fermer' : 'Tout ouvrir'}
          </button>
        </div>
      </div>

      <div className="server-table-wrapper">
        <table className="server-table">
          <thead>
            <tr>
              <th>Serveur</th>
              <th>Rôle</th>
              <th>Statut</th>
              <th>Métriques</th>
              <th>Dernière màj</th>
              <th style={{ textAlign: 'right' }}>Actions</th>
            </tr>
          </thead>
          <tbody>
            {visible.map(server => {
              const id = server.serveur_id || server.serveur_name;
              return (
                <ServerRow
                  key={id}
                  server={server}
                  expanded={expandedIds.has(id)}
                  onToggle={() => toggleRow(id)}
                  onMetricClick={onMetricClick}
                  onOpenDrawer={onOpenDrawer}
                />
              );
            })}
          </tbody>
        </table>
      </div>
    </section>
  );
}

export default ServerSection;
